/* tslint:disable */
/* eslint-disable */
/**
 * API
 * This document specifies the application programming interface (API) for Hellewi.  # URL format  `https://api.<domain>/<version>/<tenant>/<language>/<endpoint>`  e.g. `https://api.opistopalvelut.fi/v1/demo/fi/courses`  - protocol: `https` ssl must be used. - domain: `opistopalvelut.fi` domain should be the same as with tenant\'s   admin and registration domain (i.e. not necessarily opistopalvelut.fi). - version: `v1` marks the API version, only v1 is supported. - tenant: `demo` is the tenant name, should be the same as with   admin/registration url - language: `fi` is language selection, options fi/en/sv are supported - endpoint: `courses` api endpoint  Tenant must be given also inside [JWT](#section/Authentication/JWT), and it must match the tenant/domain in URL.  ## Multi-tenant request  `https://api.linnunrata.fi/<version>/<language>/<endpoint>`  e.g. `https://api.linnunrata.fi/v1/fi/courses`  This will search for courses from all the tenants that the used api key can access. All endpoints do not support multi-tenancy, those that do are listed under tag [MultiTenant](#tag/MultiTenant).  # Testing API  - url: `https://api.opistopalvelut.fi/v1/demo/fi/` - api key: `demo` - secret: `salasana`  Testing API can access only the demo tenant (\"database\" or \"client\"). You can however access multiple tenants with the same API key depending on your license.  # Search  Search query API follows [GitHub Search](https://developer.github.com/v3/search) closely.  Search string is in format `?q=SEARCH_TERM_1+SEARCH_TERM_N+FILTER_1+FILTER_N`, e.g. search terms and filters combined with `+` signs or url-encoded spaces `%20`.  Search terms are keywords to be searched. Disallowed characters are: `: + \" \'`. Results are sorted by default based on matching: best matching entries first.  ### Filters  Filters are in format `field:value`. In this simplest case, the field must be equal to the given value.  If there are multiple filters defined, results must match *all* different filters. If there are multiple filter values for the same field, results must match *one* of those. For example: `?q=department:3+subject:1+subject:2` means that all courses with department 3 and subject 1 or 2.  ### Filter operators  Supported operators in filters: - `:` equality, for example: `subject:1` - `:!` not, for example: `department:!2` - `:<` less than, for example: `distancesoft:<10km` - `:<=` less than or equal, for example: `ends:<=2020-02-01` - `:>` greater than, for example: `begins:>2019-01-01` - `:>=` greater than or equal, for example: `begins:>=2019-01-01`  ## Pagination  Pagination is handled with response headers.  Unfortunately these are not included in swagger.json due to technical restrictions in the spec generation.  ### link  `link` follows [RFC5988](https://tools.ietf.org/html/rfc5988#section-5) and [GitHub pagination](https://developer.github.com/v3/guides/traversing-with-pagination/): there are at most four links:   - `rel=\"first\"` gives the first page of results with current filters   - `rel=\"prev\"` previous page   - `rel=\"next\"` next page   - `rel=\"last\"` last page  For example (linefeeds added):      GET https://api.opistopalvelut.fi/v1/demo/fi/courses?page=5&limit=2      link: <https://api.opistopalvelut.fi/v1/demo/fi/courses?page=1&limit=2>; rel=\"first\",           <https://api.opistopalvelut.fi/v1/demo/fi/courses?page=4&limit=2>; rel=\"prev\",           <https://api.opistopalvelut.fi/v1/demo/fi/courses?page=6&limit=2>; rel=\"next\",           <https://api.opistopalvelut.fi/v1/demo/fi/courses?page=14&limit=2>; rel=\"last\"  If the query is for the first page, first and prev are omitted. Similarly, if the query is for the last page, last and next are omitted.  If there are no results, all links are omitted.  The link-header should be used for creating pagination functionality.  ### x-total-count  `x-total-count` is the total number of items in result set.  For example:      GET https://api.opistopalvelut.fi/v1/demo/fi/courses?page=5&limit=2      x-total-count: 29  The maximum number here is 10000. If you are expecting a bigger number, or are interested only in the total course count and not the results itself, you should be using [GetCourseCount](#operation/GetCourseCount).  ## Course search  Field explanations by name can be found from [ListCourses](#operation/ListCourses) response schema.  ### Search term  Search term matches text in following course fields with relative weights in parenthesis:  - name (10) - code (7) - teacher (5) - subject (4) - location (3) - category (2) - description (1)  Search terms can have multiple words combined with double quotation marks `\"`.  For example:  `?q=jooga` search term \"jooga\" (probably in course name)  `?q=830107+\"dynaaminen jooga\"` search terms \"830107\" and \"dynaaminen jooga\"  ### Equality filters by id  - category - classification - department - educationsector - language - levelofstudy - location - moduleparent (also null works) - period - subject - tag - tenant - term - weekday  Category can be queried with a path \"department/category\" and subject with \"department/category/subject\" or \"category/subject\".  Tenant makes sense only in the context of multi-tenant requests.  For example:  `?q=department:3+subject:1+subject:2` all courses with department 3 *and* subject 1 *or* 2  `q=weekday:1` courses that have lessons on Monday  `q=moduleparent:18` module child courses that have parent course 18  `q=moduleparent:null` all courses that are not module child courses  ### Date filters  - begins (date-only, YYYY-MM-DD) - ends (date-only, YYYY-MM-DD) - registrationbegins (date-time, YYYY-MM-DDTHH:MM:SSZ) - registrationendssoft (date-time, YYYY-MM-DDTHH:MM:SSZ) - registrationendshard (date-time, YYYY-MM-DDTHH:MM:SSZ)  For example:  `?q=begins:>=2019-01-01`: courses that begin after or on 1.1.2019  ### Distance filters  - distancefrom (origin coordinates: \\<latitude\\>,\\<longitude\\>) - distancehard (distance: \\<number\\>km or \\<number\\>m), if course\'s   location is farther, course will not be included in results - distancesoft (distance: \\<number\\>km or \\<number\\>m), will return all   courses ordered by distance, courses farther than this distance will   be ranked considerably lower (but if only this filter is used, value   can be anything)  distancefrom must be given if either filter is used. Only less than operator `:<` is supported for distancehard and distancesoft.  For example:  `?q=distancefrom:60.169,24.944+distancehard:<50km+distancesoft:<10km`: courses that are closer than 50km from 60.169,24.944, ordered by proximity  ### Other filters  - registrationopen (boolean, only true supported)  registration is currently open. See rules in [Registration](#section/Registration).  For example:  `?q=registrationopen:true`: courses where registration is open currently  ### Distance learning (etäopetus)  Distance learning courses have a special location `distancelearning`:  `?q=location:distancelearning`: only distance learning courses  `?q=location:!distancelearning`: only non-distance learning (lähiopetus) courses  ### Additional examples  `?q=jooga+category:2`: search term \"jooga\" in category 2 courses  `?q=department:3+subject:1+subject:2` all courses with department 3 *and* subject 1 *or* 2  `?q=jooga+begins:>=2019-01-01` search term \"jooga\" in courses that begin after or on 1.1.2019  # Registration  Deciding whether you can register to a course follows these rules that are compared in order (i.e. when a rule matches, the rest are not evaluated): 1. current time < course.registrationbegins: **registration IS NOT open**<br>    Registration is not yet started. 2. course.ends < current time: **registration IS NOT open**<br>    Course has already ended. If course ending time is not defined, this    step is skipped. 3. current time < course.registrationendshard: **registration IS open**<br>    Registration is not yet ended. 4. otherwise: **registration IS NOT open**  Admin interface has only one time for registration ending. It also has a global setting for making that ending time either a soft or hard deadline. API registrationendshard takes this global setting into account (it will be null if registrationends is a soft deadline). Also, if registration beginning or ending time is undefined in admin interface, they will be null in API (i.e. registrationbegins null => registration not open, registrationends null => registration is open).  ## Registration to lessons  Some courses can have registration to single or multiple lessons in addition to registration to the whole course. Registering to lessons can be enabled from admin interface, and is possible if registration to the course is open, and if there is available places in that lesson.  Selecting a price means that registration is for the whole course, where selecting lessons means that registration is only for the specified lessons. Both options are not always present, they follow these rules:  1. If course has registration to lessons (\"registration practice\" /    \"ilmoittautumistapa: ilmoittautuminen kerroille\") and lessons defined,    lessons can be selected. 2. If registration to lessons is restricted (\"lesson registration limit\" /    \"kuinka monelle seuraavalle kerralle voi ilmoittautua\"), prices cannot    be selected. 3. If registration to lessons doesn\'t cost anything (\"single lesson fee\" /    \"kertamaksu\" 0,00 e) and all course prices are also zero, prices (and    lessons) can be selected. 4. If registration to lessons cost something and all course prices are    *not* zero, prices (and lessons) can be selected. 5. If course doesn\'t have any prices and registration to lessons is free,    leaving lessons empty is also allowed, which means that the registration    is for the whole course.  Note that even when prices and lessons are both selectable, user cannot select both at the same time.  Registration to lessons\' spare places is not possible.  ## Selecting installments  Prices can have one or more installment groups that can be selected as payment option. Installment options can also expire so that for example course has separate installments for fall and spring period, and fall installment is only valid until the change of period.  Course can have prices with installments and prices without installments at the same time. If a course price has installments, selecting one is required.  ## How price is calculated  1. Lessons selected: price will be the price of combined lessons 2. Spare place: price for a spare place course is always zero 3. Installments selected: price that can or has to be paid after registration    will be the price of the first installment, other installments will be    billed later 4. Otherwise: price will be the selected price  # Rate limit  Requests to API are rate limited to 100 requests per 10 seconds. When this rate limit is exceeded, API will respond with HTTP status code 429 too many requests.  # JWT authentication  Required fields for header are: - `typ` must always be \'JWT\' - `alg` JWT signing algorithm, supported algorithms are: \'HS256\',   \'HS384\' and \'HS512\' - `kid` API key (*not* secret), \'demo\' can be used for testing with   demo data  Required fields for payload are: - `sub` subject, must be \'hellewi-api-v1\' for this API - `iat` issued at (unix timestamp) - `exp` expiration time (unix timestamp). Maximum expiration time is   one week in the future. When using key id \'demo\', this is not   enforced. - `tenant` tenant identifier, this is in format `<tenant>.<domain>`,   e.g. for opistopalvelut.fi/demo tenant is demo.opistopalvelut.fi - `jti` JWT id, unique identifier, used for identifying sessions. This   must be a random string.  More information about JWTs and an excellent tool for generating JWT tokens for testing can be found at [jwt.io](https://jwt.io).  JWT formatting can be tested against [JWT status endpoint](#operation/GetStatusJwt)  For simple authentication testing, here is a ready-made JWT:  Header: ```json {   \"alg\": \"HS256\",   \"typ\": \"JWT\",   \"kid\": \"demo\" } ```  Payload: ```json {   \"iat\": 1516239022,   \"exp\": 2524608000,   \"sub\": \"hellewi-api-v1\",   \"tenant\": \"demo.opistopalvelut.fi\",   \"jti\": \"ahtu0aiWo4aMooshie9waethae7cuaj0ua2uichieshaevee3j\" } ```  Secret: `salasana`  Encoded (linefeeds added): ```markup eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImRlbW8ifQ.eyJpYXQiOjE1 MTYyMzkwMjIsInN1YiI6ImhlbGxld2ktYXBpLXYxIiwidGVuYW50IjoiZGVtby5vcGl zdG9wYWx2ZWx1dC5maSIsImp0aSI6ImFodHUwYWlXbzRhTW9vc2hpZTl3YWV0aGFlN2 N1YWowdWEydWljaGllc2hhZXZlZTNqIiwiZXhwIjoyNTI0NjA4MDAwfQ.BhzoUPL7Vm LCsrtTaZ2yyPIljYNZEiUyoayqRYchm3g ```  Shell command: ```bash curl -v -H \"Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXV CIsImtpZCI6ImRlbW8ifQ.eyJpYXQiOjE1MTYyMzkwMjIsInN1YiI6ImhlbGxld2ktY XBpLXYxIiwidGVuYW50IjoiZGVtby5vcGlzdG9wYWx2ZWx1dC5maSIsImp0aSI6ImFo dHUwYWlXbzRhTW9vc2hpZTl3YWV0aGFlN2N1YWowdWEydWljaGllc2hhZXZlZTNqIiw iZXhwIjoyNTI0NjA4MDAwfQ.BhzoUPL7VmLCsrtTaZ2yyPIljYNZEiUyoayqRYchm3g\" https://api.opistopalvelut.fi/v1/demo/fi/status/jwt ```  # HMAC request signing  JWT authentication is used on server to server communication, but sometimes there is a need for authenticating requests that originate from user\'s browser, such as viewing previously done registrations.  Note that the signed request links must be generated in a backend service as the signing uses api secret which must not be given to users.  Fields used for HMAC calculation, example from [GetStatusHmac](#operation/GetStatusHmac):   - all request parameters *except* `hmac`:     - `reqid`: random UUIDv4 string, e.g.       \'9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d\'     - `expiry`: expiration time in ISO8601 format, e.g.       \'2023-06-15T06:00:00Z\'     - there probably are also other parameters, depending on the endpoint   - two additional parameters that are *not* in the actual request:     - `scope`: endpoint HMAC scope, this is show in each endpoint\'s       authorizations-section and start with \'hmac-\',       e.g. \'hmac-status-required\'     - `tenant`: same tenant string as is used in JWT authentication,       e.g. \'demo.opistopalvelut.fi\'  All listed parameters are then ordered alphabetically and url-encoded as if they were normal query parameters (linefeed added):  ```markup expiry=2023-06-15T06%3A00%3A00Z&reqid=9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d& scope=hmac-status-required&tenant=demo.opistopalvelut.fi ```  Then HMAC digest is calculated with SHA-256 using api secret. Above with secret `salasana`:  ```markup 88290d424fa7bc11afc22140346ba3f3fa0552bff121fb6fb63c60deec7b796a ```  This is used as the request `hmac` parameter value.  So after all the request is (linefeeds added): ```markup https://api.opistopalvelut.fi/v1/demo/fi/status/hmac ?expiry=2023-06-15T06%3A00%3A00Z &reqid=9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d &hmac=88290d424fa7bc11afc22140346ba3f3fa0552bff121fb6fb63c60deec7b796a ```  HMAC can be tested against [HMAC status endpoint](#operation/GetStatusHmac). JWT must be used there as well:  ```bash curl -v -H \"Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXV CIsImtpZCI6ImRlbW8ifQ.eyJpYXQiOjE1MTYyMzkwMjIsInN1YiI6ImhlbGxld2ktY XBpLXYxIiwidGVuYW50IjoiZGVtby5vcGlzdG9wYWx2ZWx1dC5maSIsImp0aSI6ImFo dHUwYWlXbzRhTW9vc2hpZTl3YWV0aGFlN2N1YWowdWEydWljaGllc2hhZXZlZTNqIiw iZXhwIjoyNTI0NjA4MDAwfQ.BhzoUPL7VmLCsrtTaZ2yyPIljYNZEiUyoayqRYchm3g\" \"https://api.opistopalvelut.fi/v1/demo/fi/status/hmac ?expiry=2023-06-15T06%3A00%3A00Z &reqid=9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d &hmac=88290d424fa7bc11afc22140346ba3f3fa0552bff121fb6fb63c60deec7b796a\" ```  ## Node.js implementation  Uses `date-fns` and `uuid` external libraries, and node.js `crypto`.  ```javascript import { createHmac } from \'crypto\'; import { addYears } from \'date-fns\'; import { v4 as uuidv4 } from \'uuid\';  const HMAC_ALGORITHM = \'sha256\'; const API_SECRET = \'salasana\'; // use proper secret handling  const queryParamsWithoutHmac = {   // use shorter expiration   expiry: addYears(new Date(), 2).toISOString(),   reqid: uuidv4() };  const hmacCalculationParams = {   ...queryParamsWithoutHmac,   scope: \'hmac-status-required\',   tenant: \'demo.opistopalvelut.fi\' };  const hmacCalculationURLSearchParams = new URLSearchParams(   hmacCalculationParams ); hmacCalculationURLSearchParams.sort();  const hmac = createHmac(HMAC_ALGORITHM, API_SECRET)   .update(hmacCalculationURLSearchParams.toString())   .digest(\'hex\');  const queryParams = {   ...queryParamsWithoutHmac,   hmac };  const urlSearchParams = new URLSearchParams(queryParams);  console.log(queryParams); console.log(urlSearchParams.toString()); ```  Prints out: ```markup {   reqid: \'09d1eb20-1b84-4af6-935b-6de0db0b3e75\',   expiry: \'2024-01-05T10:32:50.646Z\',   hmac: \'27d7d2d4136f9e4962a6058296864f15985f81086d145ae687075ce60510c987\' } reqid=09d1eb20-1b84-4af6-935b-6de0db0b3e75&expiry=2024-01-05T10%3A32%3A50.646Z&hmac=27d7d2d4136f9e4962a6058296864f15985f81086d145ae687075ce60510c987 ``` 
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: perttu.tikka@hellewi.fi
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HellewiAgeLimits } from './HellewiAgeLimits';
import {
    HellewiAgeLimitsFromJSON,
    HellewiAgeLimitsFromJSONTyped,
    HellewiAgeLimitsToJSON,
} from './HellewiAgeLimits';
import type { HellewiCatalogItem } from './HellewiCatalogItem';
import {
    HellewiCatalogItemFromJSON,
    HellewiCatalogItemFromJSONTyped,
    HellewiCatalogItemToJSON,
} from './HellewiCatalogItem';
import type { HellewiCourseDay } from './HellewiCourseDay';
import {
    HellewiCourseDayFromJSON,
    HellewiCourseDayFromJSONTyped,
    HellewiCourseDayToJSON,
} from './HellewiCourseDay';
import type { HellewiCourseLesson } from './HellewiCourseLesson';
import {
    HellewiCourseLessonFromJSON,
    HellewiCourseLessonFromJSONTyped,
    HellewiCourseLessonToJSON,
} from './HellewiCourseLesson';
import type { HellewiCourseNotification } from './HellewiCourseNotification';
import {
    HellewiCourseNotificationFromJSON,
    HellewiCourseNotificationFromJSONTyped,
    HellewiCourseNotificationToJSON,
} from './HellewiCourseNotification';
import type { HellewiCoursePartial } from './HellewiCoursePartial';
import {
    HellewiCoursePartialFromJSON,
    HellewiCoursePartialFromJSONTyped,
    HellewiCoursePartialToJSON,
} from './HellewiCoursePartial';
import type { HellewiCoursePeriod } from './HellewiCoursePeriod';
import {
    HellewiCoursePeriodFromJSON,
    HellewiCoursePeriodFromJSONTyped,
    HellewiCoursePeriodToJSON,
} from './HellewiCoursePeriod';
import type { HellewiCoursePrice } from './HellewiCoursePrice';
import {
    HellewiCoursePriceFromJSON,
    HellewiCoursePriceFromJSONTyped,
    HellewiCoursePriceToJSON,
} from './HellewiCoursePrice';
import type { HellewiCourseProduct } from './HellewiCourseProduct';
import {
    HellewiCourseProductFromJSON,
    HellewiCourseProductFromJSONTyped,
    HellewiCourseProductToJSON,
} from './HellewiCourseProduct';
import type { HellewiCourseStatus } from './HellewiCourseStatus';
import {
    HellewiCourseStatusFromJSON,
    HellewiCourseStatusFromJSONTyped,
    HellewiCourseStatusToJSON,
} from './HellewiCourseStatus';
import type { HellewiFile } from './HellewiFile';
import {
    HellewiFileFromJSON,
    HellewiFileFromJSONTyped,
    HellewiFileToJSON,
} from './HellewiFile';
import type { HellewiImage } from './HellewiImage';
import {
    HellewiImageFromJSON,
    HellewiImageFromJSONTyped,
    HellewiImageToJSON,
} from './HellewiImage';
import type { HellewiLanguage } from './HellewiLanguage';
import {
    HellewiLanguageFromJSON,
    HellewiLanguageFromJSONTyped,
    HellewiLanguageToJSON,
} from './HellewiLanguage';
import type { HellewiLocation } from './HellewiLocation';
import {
    HellewiLocationFromJSON,
    HellewiLocationFromJSONTyped,
    HellewiLocationToJSON,
} from './HellewiLocation';
import type { HellewiParticipantCount } from './HellewiParticipantCount';
import {
    HellewiParticipantCountFromJSON,
    HellewiParticipantCountFromJSONTyped,
    HellewiParticipantCountToJSON,
} from './HellewiParticipantCount';
import type { HellewiTag } from './HellewiTag';
import {
    HellewiTagFromJSON,
    HellewiTagFromJSONTyped,
    HellewiTagToJSON,
} from './HellewiTag';

/**
 * 
 * @export
 * @interface HellewiCourse
 */
export interface HellewiCourse {
    [key: string]: any | any;
    /**
     * Course ID
     * 
     * This is either
     * - a number as string (single-tenant endpoints, e.g. `'3'`)
     * - string with tenant id (in lowercase) and course id number (multi-tenant
     *   endpoints, e.g. `'demo.opistopalvelut.fi-3'`)
     * 
     * Validation pattern: `^(?:[a-z0-9-.]+-)?[0-9]+$`
     * @type {string}
     * @memberof HellewiCourse
     */
    id: string;
    /**
     * Code / koodi
     * @type {string}
     * @memberof HellewiCourse
     */
    code?: string;
    /**
     * Name
     * @type {string}
     * @memberof HellewiCourse
     */
    name?: string;
    /**
     * Tenant
     * @type {string}
     * @memberof HellewiCourse
     */
    tenant: string;
    /**
     * Course statuses
     * 
     * - `NOT_YET_STARTED` Course has not yet started
     * - `IN_PROGRESS` Course is in progress
     * - `ENDED` Course has ended
     * - `CANCELLED` Course has been cancelled (before it started)
     * - `INTERRUPTED` Course has been interrupted (after it started)
     * 
     * Currently only one of the statuses can be active at the same time, but
     * it is also possible that none of them are.
     * 
     * Statuses can be added in the future, so the field is an array, and
     * implementation cannot make any assumptions that the requested status
     * would be always in index 0.
     * @type {Array<HellewiCourseStatus>}
     * @memberof HellewiCourse
     */
    statuses: Array<HellewiCourseStatus>;
    /**
     * Course begins on date
     * @type {Date}
     * @memberof HellewiCourse
     */
    begins?: Date;
    /**
     * Course ends on date
     * @type {Date}
     * @memberof HellewiCourse
     */
    ends?: Date;
    /**
     * Registration begins on date/time
     * 
     * null means that registration is not open
     * @type {Date}
     * @memberof HellewiCourse
     */
    registrationbegins?: Date;
    /**
     * Registration ends on date/time, soft limit
     * 
     * If this time is in the past, registrations are still accepted, but
     * user interfaces should show this field as time when registrations close
     * @type {Date}
     * @memberof HellewiCourse
     */
    registrationendssoft?: Date;
    /**
     * Registration ends on date/time, hard limit
     * 
     * null means that registration has no ending limit
     * @type {Date}
     * @memberof HellewiCourse
     */
    registrationendshard?: Date;
    /**
     * Whether registration is open at the moment
     * 
     * See rules in [Registration](#section/Registration)
     * @type {boolean}
     * @memberof HellewiCourse
     */
    registrationopen?: boolean;
    /**
     * Teacher
     * @type {string}
     * @memberof HellewiCourse
     */
    teacher?: string;
    /**
     * ECTS credits / opintopisteet
     * @type {number}
     * @memberof HellewiCourse
     */
    ectscredits?: number;
    /**
     * Topical / ajankohtainen
     * 
     * This course should be emphasized
     * @type {boolean}
     * @memberof HellewiCourse
     */
    topical?: boolean;
    /**
     * Day(s) / kurssipäivät
     * @type {Array<HellewiCourseDay>}
     * @memberof HellewiCourse
     */
    days?: Array<HellewiCourseDay>;
    /**
     * 
     * @type {HellewiLocation}
     * @memberof HellewiCourse
     */
    location?: HellewiLocation;
    /**
     * Notification
     * @type {Array<HellewiCourseNotification>}
     * @memberof HellewiCourse
     */
    notifications?: Array<HellewiCourseNotification>;
    /**
     * Periods and terms / lukukaudet ja lukuvuodet
     * @type {Array<HellewiCoursePeriod>}
     * @memberof HellewiCourse
     */
    periods?: Array<HellewiCoursePeriod>;
    /**
     * 
     * @type {HellewiLanguage}
     * @memberof HellewiCourse
     */
    language?: HellewiLanguage;
    /**
     * Tags
     * @type {Array<HellewiTag>}
     * @memberof HellewiCourse
     */
    tags?: Array<HellewiTag>;
    /**
     * Prices
     * @type {Array<HellewiCoursePrice>}
     * @memberof HellewiCourse
     */
    prices?: Array<HellewiCoursePrice>;
    /**
     * 
     * @type {HellewiCoursePartial}
     * @memberof HellewiCourse
     */
    moduleparent?: HellewiCoursePartial;
    /**
     * Child courses for a module parent course
     * @type {Array<HellewiCoursePartial>}
     * @memberof HellewiCourse
     */
    modulechildren?: Array<HellewiCoursePartial>;
    /**
     * Catalog items
     * 
     * Different item types are explained under [GetCatalog](#operation/GetCatalog)
     * response
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCourse
     */
    catalogitems: Array<HellewiCatalogItem>;
    /**
     * 
     * @type {HellewiAgeLimits}
     * @memberof HellewiCourse
     */
    ageLimits?: HellewiAgeLimits;
    /**
     * Course products
     * @type {Array<HellewiCourseProduct>}
     * @memberof HellewiCourse
     */
    courseProducts?: Array<HellewiCourseProduct>;
    /**
     * 
     * @type {HellewiCatalogItem}
     * @memberof HellewiCourse
     */
    department?: HellewiCatalogItem;
    /**
     * 
     * @type {HellewiCatalogItem}
     * @memberof HellewiCourse
     */
    category?: HellewiCatalogItem;
    /**
     * 
     * @type {HellewiCatalogItem}
     * @memberof HellewiCourse
     */
    subject?: HellewiCatalogItem;
    /**
     * Description
     * @type {string}
     * @memberof HellewiCourse
     */
    description?: string;
    /**
     * Additionalinfo
     * @type {string}
     * @memberof HellewiCourse
     */
    additionalinfo?: string;
    /**
     * Ask about the course / kysy kurssista
     * @type {string}
     * @memberof HellewiCourse
     */
    askabout?: string;
    /**
     * Learningobjectives
     * @type {string}
     * @memberof HellewiCourse
     */
    learningobjectives?: string;
    /**
     * Evaluationcriteria
     * @type {string}
     * @memberof HellewiCourse
     */
    evaluationcriteria?: string;
    /**
     * Keywords that can be used to match filters
     * @type {Array<string>}
     * @memberof HellewiCourse
     */
    keywords?: Array<string>;
    /**
     * Lessons
     * @type {Array<HellewiCourseLesson>}
     * @memberof HellewiCourse
     */
    lessons?: Array<HellewiCourseLesson>;
    /**
     * Metakeywords
     * @type {string}
     * @memberof HellewiCourse
     */
    metakeywords?: string;
    /**
     * 
     * @type {HellewiParticipantCount}
     * @memberof HellewiCourse
     */
    participantcount?: HellewiParticipantCount;
    /**
     * Link for course registration
     * 
     * This opens Hellewi registration application registration form with this
     * course added to cart.
     * @type {string}
     * @memberof HellewiCourse
     */
    registrationlink?: string;
    /**
     * Files
     * @type {Array<HellewiFile>}
     * @memberof HellewiCourse
     */
    files?: Array<HellewiFile>;
    /**
     * Images
     * @type {Array<HellewiImage>}
     * @memberof HellewiCourse
     */
    images?: Array<HellewiImage>;
}

/**
 * Check if a given object implements the HellewiCourse interface.
 */
export function instanceOfHellewiCourse(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('tenant' in value)) return false;
    if (!('statuses' in value)) return false;
    if (!('catalogitems' in value)) return false;
    return true;
}

export function HellewiCourseFromJSON(json: any): HellewiCourse {
    return HellewiCourseFromJSONTyped(json, false);
}

export function HellewiCourseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HellewiCourse {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'id': json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'tenant': json['tenant'],
        'statuses': ((json['statuses'] as Array<any>).map(HellewiCourseStatusFromJSON)),
        'begins': json['begins'] == null ? undefined : (new Date(json['begins'])),
        'ends': json['ends'] == null ? undefined : (new Date(json['ends'])),
        'registrationbegins': json['registrationbegins'] == null ? undefined : (new Date(json['registrationbegins'])),
        'registrationendssoft': json['registrationendssoft'] == null ? undefined : (new Date(json['registrationendssoft'])),
        'registrationendshard': json['registrationendshard'] == null ? undefined : (new Date(json['registrationendshard'])),
        'registrationopen': json['registrationopen'] == null ? undefined : json['registrationopen'],
        'teacher': json['teacher'] == null ? undefined : json['teacher'],
        'ectscredits': json['ectscredits'] == null ? undefined : json['ectscredits'],
        'topical': json['topical'] == null ? undefined : json['topical'],
        'days': json['days'] == null ? undefined : ((json['days'] as Array<any>).map(HellewiCourseDayFromJSON)),
        'location': json['location'] == null ? undefined : HellewiLocationFromJSON(json['location']),
        'notifications': json['notifications'] == null ? undefined : ((json['notifications'] as Array<any>).map(HellewiCourseNotificationFromJSON)),
        'periods': json['periods'] == null ? undefined : ((json['periods'] as Array<any>).map(HellewiCoursePeriodFromJSON)),
        'language': json['language'] == null ? undefined : HellewiLanguageFromJSON(json['language']),
        'tags': json['tags'] == null ? undefined : ((json['tags'] as Array<any>).map(HellewiTagFromJSON)),
        'prices': json['prices'] == null ? undefined : ((json['prices'] as Array<any>).map(HellewiCoursePriceFromJSON)),
        'moduleparent': json['moduleparent'] == null ? undefined : HellewiCoursePartialFromJSON(json['moduleparent']),
        'modulechildren': json['modulechildren'] == null ? undefined : ((json['modulechildren'] as Array<any>).map(HellewiCoursePartialFromJSON)),
        'catalogitems': ((json['catalogitems'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'ageLimits': json['ageLimits'] == null ? undefined : HellewiAgeLimitsFromJSON(json['ageLimits']),
        'courseProducts': json['courseProducts'] == null ? undefined : ((json['courseProducts'] as Array<any>).map(HellewiCourseProductFromJSON)),
        'department': json['department'] == null ? undefined : HellewiCatalogItemFromJSON(json['department']),
        'category': json['category'] == null ? undefined : HellewiCatalogItemFromJSON(json['category']),
        'subject': json['subject'] == null ? undefined : HellewiCatalogItemFromJSON(json['subject']),
        'description': json['description'] == null ? undefined : json['description'],
        'additionalinfo': json['additionalinfo'] == null ? undefined : json['additionalinfo'],
        'askabout': json['askabout'] == null ? undefined : json['askabout'],
        'learningobjectives': json['learningobjectives'] == null ? undefined : json['learningobjectives'],
        'evaluationcriteria': json['evaluationcriteria'] == null ? undefined : json['evaluationcriteria'],
        'keywords': json['keywords'] == null ? undefined : json['keywords'],
        'lessons': json['lessons'] == null ? undefined : ((json['lessons'] as Array<any>).map(HellewiCourseLessonFromJSON)),
        'metakeywords': json['metakeywords'] == null ? undefined : json['metakeywords'],
        'participantcount': json['participantcount'] == null ? undefined : HellewiParticipantCountFromJSON(json['participantcount']),
        'registrationlink': json['registrationlink'] == null ? undefined : json['registrationlink'],
        'files': json['files'] == null ? undefined : ((json['files'] as Array<any>).map(HellewiFileFromJSON)),
        'images': json['images'] == null ? undefined : ((json['images'] as Array<any>).map(HellewiImageFromJSON)),
    };
}

export function HellewiCourseToJSON(value?: HellewiCourse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
            ...value,
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'tenant': value['tenant'],
        'statuses': ((value['statuses'] as Array<any>).map(HellewiCourseStatusToJSON)),
        'begins': value['begins'] == null ? undefined : ((value['begins']).toISOString().substring(0,10)),
        'ends': value['ends'] == null ? undefined : ((value['ends']).toISOString().substring(0,10)),
        'registrationbegins': value['registrationbegins'] == null ? undefined : ((value['registrationbegins']).toISOString()),
        'registrationendssoft': value['registrationendssoft'] == null ? undefined : ((value['registrationendssoft']).toISOString()),
        'registrationendshard': value['registrationendshard'] == null ? undefined : ((value['registrationendshard']).toISOString()),
        'registrationopen': value['registrationopen'],
        'teacher': value['teacher'],
        'ectscredits': value['ectscredits'],
        'topical': value['topical'],
        'days': value['days'] == null ? undefined : ((value['days'] as Array<any>).map(HellewiCourseDayToJSON)),
        'location': HellewiLocationToJSON(value['location']),
        'notifications': value['notifications'] == null ? undefined : ((value['notifications'] as Array<any>).map(HellewiCourseNotificationToJSON)),
        'periods': value['periods'] == null ? undefined : ((value['periods'] as Array<any>).map(HellewiCoursePeriodToJSON)),
        'language': HellewiLanguageToJSON(value['language']),
        'tags': value['tags'] == null ? undefined : ((value['tags'] as Array<any>).map(HellewiTagToJSON)),
        'prices': value['prices'] == null ? undefined : ((value['prices'] as Array<any>).map(HellewiCoursePriceToJSON)),
        'moduleparent': HellewiCoursePartialToJSON(value['moduleparent']),
        'modulechildren': value['modulechildren'] == null ? undefined : ((value['modulechildren'] as Array<any>).map(HellewiCoursePartialToJSON)),
        'catalogitems': ((value['catalogitems'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'ageLimits': HellewiAgeLimitsToJSON(value['ageLimits']),
        'courseProducts': value['courseProducts'] == null ? undefined : ((value['courseProducts'] as Array<any>).map(HellewiCourseProductToJSON)),
        'department': HellewiCatalogItemToJSON(value['department']),
        'category': HellewiCatalogItemToJSON(value['category']),
        'subject': HellewiCatalogItemToJSON(value['subject']),
        'description': value['description'],
        'additionalinfo': value['additionalinfo'],
        'askabout': value['askabout'],
        'learningobjectives': value['learningobjectives'],
        'evaluationcriteria': value['evaluationcriteria'],
        'keywords': value['keywords'],
        'lessons': value['lessons'] == null ? undefined : ((value['lessons'] as Array<any>).map(HellewiCourseLessonToJSON)),
        'metakeywords': value['metakeywords'],
        'participantcount': HellewiParticipantCountToJSON(value['participantcount']),
        'registrationlink': value['registrationlink'],
        'files': value['files'] == null ? undefined : ((value['files'] as Array<any>).map(HellewiFileToJSON)),
        'images': value['images'] == null ? undefined : ((value['images'] as Array<any>).map(HellewiImageToJSON)),
    };
}

